import CurrencyExchangeDirective from './currency-exchange';

export default angular
    .module('paysera.currencyExchange.directives', [])
    .directive('currencyExchange', CurrencyExchangeDirective)
    .name
;
